exports = module.exports = require("../../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.admin__filter[data-v-a5f571ce] {\n  background: #fff;\n  padding: 20px;\n  padding-bottom: 0;\n  -webkit-border-top-left-radius: 3px;\n  -webkit-border-top-right-radius: 3px;\n  -moz-border-radius-topleft: 3px;\n  -moz-border-radius-topright: 3px;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-a5f571ce","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/sass-loader?{"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Admin/Components/AdminFilter.vue
// module id = 800
// module chunks = 1